import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import backgroundimage from "../../assets/Background10.png";
import pic1 from "../../assets/Picwithiran.png";
import pic2 from "../../assets/SecondPhoto.png";

const SomethingMore = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <section
      className="w-full bg-cover bg-center bg-no-repeat py-12 sm:py-16 lg:py-20 lg:mt-8 mt-5"
      style={{ backgroundImage: `url(${backgroundimage})` }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <h1
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-green-400 dmsans mb-4 sm:mb-6 lg:mb-4"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          Something More About Me!
        </h1>

        {/* First Section */}
        <div className="flex flex-col lg:flex-row gap-5 lg:gap-6 mb-6 sm:mb-8 lg:mb-10 justify-center items-center">
          <div className="w-full lg:w-3/5 order-2 lg:order-1">
            <div
              className="space-y-6"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed heebo text-justify">
                Sailesh Dani's contributions across multiple domains showcase
                his vision, professionalism, and commitment to excellence,
                driving positive change. Sailesh Dani, renowned for his
                innovative ideas and exceptional technical expertise, has been
                honored with the prestigious First Indian Brand Icon Award for
                Eastern India. This recognition celebrates his groundbreaking
                contributions across multiple domains and his unwavering
                commitment to excellence.
              </p>
              <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed heebo text-justify">
                As a pioneer, Sailesh Dani is also the first manufacturer to
                design and introduce hydraulic access platforms in Odisha,
                setting a new standard for efficiency and innovation in the
                industry.
              </p>
            </div>
          </div>
          <div className="w-full lg:w-2/5 order-1 lg:order-2">
            <div
              className="relative h-full"
              data-aos="flip-left"
              data-aos-duration="1000"
            >
              <img
                src={pic1}
                alt="Award Image"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>

        {/* Second Section */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="w-full lg:w-2/5">
            <div
              className="relative h-full"
              data-aos="flip-right"
              data-aos-duration="1000"
            >
              <img
                src={pic2}
                alt="Hydraulic Access Platform"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <div
              className="h-full flex items-center"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed heebo text-justify">
                Sailesh Dani, with his exceptional technical vision, introduced
                heavy tank evacuation systems, collaborating with IIT graduates
                to develop & launch the rotary oil ring vacuum pump. This
                innovative system is capable of operating on large vessels
                exceeding 5000 liters, revolutionizing the cleaning of
                overloaded tanks.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SomethingMore;
